import { Column } from '@tempmee/react';
import { LabelValueDisplay } from '../LabelValueDisplay';

interface IGeneralJobInfoPreviewProps {
  officeName: string;
  title: string;
  professionType: string;
  specialty: string;
  payType: string;
  payTitle: string;
  payRange: string;
  benefits: string;
  benefitsOther?: string;
}

export const GeneralJobInfoPreview = ({
  officeName,
  title,
  professionType,
  specialty,
  payType,
  payTitle,
  payRange,
  benefits,
  benefitsOther,
}: IGeneralJobInfoPreviewProps) => {
  return (
    <Column gap={4}>
      <LabelValueDisplay label="Office Name" value={officeName} />
      <LabelValueDisplay label="Job Title" value={title} />
      <LabelValueDisplay label="Professional Type" value={professionType} />
      <LabelValueDisplay label="Specialty" value={specialty} />
      <LabelValueDisplay label="Pay Type" value={payType} />
      <LabelValueDisplay label={payTitle} value={payRange} />
      <LabelValueDisplay label="Benefits" value={benefits} />
      {benefitsOther && <LabelValueDisplay label="Other Benefits" value={benefitsOther} />}
    </Column>
  );
};
